import React, {useEffect} from "react";
import {MediaCategory, StoredMediaCategory} from "../../../types/Media";
import { useTranslation } from "react-i18next";
import { useGlobalContext } from "../../../contexts/globalContext";
import Heading from "../../../components/Heading";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import IconButton from "../../../components/IconButton";
import DeleteCategoryModalContent from "./DeleteCategoryModalContent";
import EditCategoryModalContent from "./EditCategoryModalContent";
import Button from "../../../components/Button";
import styles from "./CategorySettings.module.scss";
import cx from "classnames";
import {useFetchData} from "../../../hooks/useFetchData";
import CategoryListItem from "./CategoryListItem";
import Loader from "../../../components/Loader";
import Text from "../../../components/Text";
import AddNewCategory from "./AddNewCategory";

const CategorySettings: React.FC<{ changeSettingsTab: (tab: string | null) => void }> = ({ changeSettingsTab }) => {
    const { showModal, closeModal } = useGlobalContext();
    const { data: categories, isLoading, fetch } = useFetchData<StoredMediaCategory>('mediaCategoriesAndCount')
    const {plugin} = useGlobalContext()
    const { t } = useTranslation(['settings']);

    const openStoreModal = () => {
        const content: JSX.Element = <div style={{minWidth: '350px'}}>
            <AddNewCategory categories={categories} onNewCategory={() => {
            fetch()
            closeModal()
        }}/></div>;
        showModal({ heading: t('categories.create_modal.heading'), content: content, fullscreen: false });
    }

    const openEditModal = (category: MediaCategory) => {
        const content: JSX.Element = <EditCategoryModalContent
            category={category}
            onSubmit={() => fetch()}
            categories={categories}
        />;
        showModal({ heading: t('categories.edit_modal.heading'), content: content, fullscreen: false });
    }


    const openDeleteModal = (category: MediaCategory) => {
        const content: JSX.Element = <DeleteCategoryModalContent
            category={category}
            onSubmit={() => fetch()}
        />;
        showModal({ heading: t('categories.delete_modal.heading'), content: content, fullscreen: false });
    }

    useEffect(() => {
        fetch();
    }, [fetch]);

    return (
        <>
            <Heading level={3} classes={'my-4'}>
                {t('categories.heading')}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={"black"}
                onClick={() => changeSettingsTab(null)}
            >
                {t('common.backToOverview')}
            </IconButton>
            <Text classes={'mt-3 mb-6'}>
                {t('categories.description')}
            </Text>
            <Button hierarchy={'secondary'} text={t('categories.add')} fn={() => openStoreModal()}/>
            {!isLoading && (
                <div className={cx(styles["table-container"])}>
                    <table className={cx(styles["zr-table"])}>
                        <thead className={cx(styles["table-header"])} >
                        <tr>
                            <th>{t('categories.name')} </th>
                            <th>{t('categories.count')}</th>
                            <th>{t('categories.actions')}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <CategoryListItem
                                paddingLeft={0}
                                parent={null} tree={categories}
                                openDeleteModal={openDeleteModal}
                                openEditModal={openEditModal}
                                fetchCategories={fetch}
                            />
                        </tbody>
                    </table>
                </div>
            )}
            {isLoading &&
                <div className={'w-100 d-flex justify-content-center'}>
                    <Loader isLoading={isLoading} size={'m'} />
                </div>
            }
        </>
    );
};

export default CategorySettings;
